import { render, staticRenderFns } from "./AnalyticsBudget.vue?vue&type=template&id=a5b12152&"
import script from "./AnalyticsBudget.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsBudget.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports